<bb-page-header [icon]="'chart-line-up'" [title]="'STATISTICS' | translate" [currentPath]="'/analytics/statistics'">
</bb-page-header>

<div class="body-column" cdk-scrollable>
	<div class="grid-container"	[class.analytics-mobile]="theme === 'analytics-mobile'">
		<div class="sidebar-container">
			<div class="sidebar">

				<mat-form-field appearance="fill" class="full-width margin-bottom">
					<mat-label>{{'SELECT_FILTER' | translate}}</mat-label>
					<span matPrefix><i class="fa fa-search"></i></span>
					<bb-entity-selector [options]="facetSelectorOptions" placeholder="" [selectOnly]="true"
						[inMatFormField]="true" [disableClear]="true" theme="light-v2" name="filterSelect"
						(optionSelected)="onFilterSelected($event)"></bb-entity-selector>
				</mat-form-field>

				<div class="divider"></div>

				<div class="filter-group" *ngFor="let facetGroup of facetGroups;">
					<div class="panel-toggle-button" [class.open]="analyticsService.status.openCat[facetGroup.title]"
						(click)="analyticsService.status.openCat[facetGroup.title] = !analyticsService.status.openCat[facetGroup.title]">
						{{ facetGroup.title }}

						<div class="toggle-icon">
							<i class="fa fa-chevron-right"></i>
							<i class="fa fa-chevron-down"></i>
						</div>
					</div>

					<div class="content" *ngIf="analyticsService.status.openCat[facetGroup.title]">
						<div class="left-line-2" [class.active]="activeId" *ngIf="facetGroup.title === 'Content'">
							<mat-form-field appearance="fill" class="analytics-clip-select full-width margin-bottom">
								<mat-label>{{'MEDIACLIP' | translate}}</mat-label>
								<bb-entity-selector [startOpen]="contentSearchOpen" placeholder=""
									[inMatFormField]="true" [hideThumbnail]="true" [hideIcons]="true" theme="light-v2"
									[entityType]="'mediaclip'" [(ngModel)]="activeId" name="clipId"
									(ngModelChange)="onSelectedClipChange()" [filterSet]="[{
										filters: [{
											type: 'commonclip',
											field: 'status',
											operator: 'is',
											value: 'published'
										}]
									},{
										filters: [{
											type: 'commonclip',
											field: 'mediatype',
											operator: 'is',
											value: 'video'
										}]
									}]"></bb-entity-selector>
							</mat-form-field>
						</div>

						<div class="filters"
							*ngIf="!(facetGroup.title === 'Content' && analyticsService.activeId && analyticsService.activeType === 'mediaclip')">
							<div class="facet-filter-container" *ngFor="let facet of facetGroup.filters; let i = index"
								[class.active]="analyticsService.status.activeFacets[facet.name]"
								[hidden]="facet.allstatsOnly && !analyticsService.isAllstats">
								<div class="facet-filter-header" [class.open]="expandedFacets[facet.name]">
									<div class="facet-filter-title" (click)="onFacetTitleClick(facet)">
										<i class="fa fa-chevron-right" [hidden]="expandedFacets[facet.name]"></i>
										<i class="fa fa-chevron-down" [hidden]="!expandedFacets[facet.name]"></i>
										<span>{{ facet.label }}</span>
									</div>
									<button type="button" *ngIf="expandedFacets[facet.name]" class="toggle-in-exclude"
										[matMenuTriggerFor]="includeMenu">
										<span>
											{{ (analyticsService?.status?.facetconfig?.[facet.name]?.not ? 'EXCLUDE' :
											'INCLUDE') | translate}}
										</span>
										<i class="fas fa-caret-down"></i>
									</button>
								</div>
								<mat-menu #includeMenu="matMenu">
									<button type="button" mat-menu-item (click)="onIncludeSelected(facet)"
										[class.selected]="!analyticsService?.status?.facetconfig?.[facet.name]?.not">
										<span class="item-icon select-only">
											<i class="fa fa-check"></i>
										</span>
										<span>{{ "INCLUDE_SELECTION" | translate }}</span>
									</button>
									<button type="button" mat-menu-item (click)="onExcludeSelected(facet)"
										[class.selected]="analyticsService?.status?.facetconfig?.[facet.name]?.not">
										<span class="item-icon select-only">
											<i class="fa fa-check"></i>
										</span>
										<span>{{ "EXCLUDE_SELECTION" | translate }}</span>
									</button>
								</mat-menu>
								<div class="facet-filter-contents" *ngIf="expandedFacets[facet.name]"
									class="facet-{{ facet.name }}">
									<bb-facet-filter [total]="views" [facet]="facet"
										[facetData]="analyticsService.facetData[facet.name]"
										(filterChange)="onFilterChange()" (highlightChange)="onFacetHighlightChange()">
									</bb-facet-filter>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="content-container" [class.analytics-mobile]="theme === 'analytics-mobile'" [class.mediaclip-details]="activeId && analyticsService.activeType === 'mediaclip'"
			[class.clip-with-timeline]="!!analyticsService.mediaclip?.timelines?.[0]">
			<div class="active-filters-area">
				<bb-active-filters [filters]="activeFilterList"></bb-active-filters>
				<div class="date-range-input">
					<bb-date-presets
						[minDate]="statsMinDate" [useMatFormField]="true" data-cy="analytics-date-picker"
						(onChanged)="onDateSelected($event)" [usePublicationTimeZone]="true" [icon]="'line-chart'"
						[presets]="datePresets" [(preset)]="analyticsService.status.daterangePreset"
						[startDate]="datePresetsSelectorService?.statsDate?.startDate"
						[endDate]="datePresetsSelectorService?.statsDate?.endDate" [theme]="theme">
					</bb-date-presets>
				</div>
			</div>

			<!-- MAIN GRAPH -->
			<bb-tile class="main-graph" [headerBar]="false" [menuOptions]="mainGraphMenuOptions"
				(menuOptionSelected)="setMenuFilter($event)"
				[loading]="mainGraphLoading || analyticsService.loadingData" [noData]="mainGraphNoData">
				<bb-chart [bbChartSettings]="{
					maxLabelRotation: 0,
					bodyColor: '#3693ef',
					showLegend: true,
					padding: 15
				}" [datasets]="viewRangeGraphDatasets" styling="analytics"></bb-chart>
			</bb-tile>

			<!-- NUMBER BLOCKS -->
			<div class="number-blocks">
				<ng-container *ngFor="let nb of numberBlocks; let i = index;">
					<bb-tile class="number-block" [loading]="analyticsService?.metrics[nb]?.loading"
						*ngIf="analyticsService?.metrics[nb]?.loading || analyticsService?.metrics[nb]?.count || analyticsService?.metrics[nb]?.count === 0">
						<bb-kpi-block 
							[loading]="analyticsService?.metrics[nb]?.loading" [mode]="'no-select'"
							[kpi]="{ 
								finalSum: analyticsService?.metrics[nb]?.count, 
								label: analyticsService?.metrics[nb]?.label, 
								description: analyticsService?.metrics[nb]?.description, 
								isFloat: analyticsService?.metrics[nb]?.type === 'float',
								isPercentage: analyticsService?.metrics[nb]?.type === 'percentage'
							}">
						</bb-kpi-block>
					</bb-tile>
				</ng-container>
			</div>

			<!-- MEDIACLIP DETAILS: CLIP INFO -->
			<bb-tile class="mediaclip-details clip-info-tile"
				*ngIf="analyticsService.activeId && analyticsService.activeType === 'mediaclip'" [headerBar]="true"
				[noData]="!analyticsService.mediaclip || analyticsService.mediaclipNotFound"
				[loading]="(!analyticsService.mediaclip && !analyticsService.mediaclipNotFound) && !analyticsService.mediaclipNotFound">
				<span class="tile-title">
					{{ 'DETAILS' | translate }}
				</span>
				<div class="clip-details-body">
					<bb-entity-details *ngIf="! analyticsService.mediaclipNotFound" [hideHeading]="true"
						[theme]="'analytics'" [entity]="analyticsService.mediaclip"></bb-entity-details>
				</div>
			</bb-tile>

			<!-- MEDIACLIP DETAILS: PREVIEW PLAYER -->
			<bb-tile class="mediaclip-details preview-player-tile"
				*ngIf="analyticsService.activeId && analyticsService.activeType === 'mediaclip' && !analyticsService.mediaclip?.timelines?.[0]" [headerBar]="false"
				[noData]="!analyticsService.mediaclip || analyticsService.mediaclipNotFound"
				[loading]="activeId && (!playerClipLoaded && !analyticsService.mediaclipNotFound)">
				<bb-player (onPlayerCreated)="onPlayerCreated($event)" [inheritDimensions]="true"
					[playoutOverrides]="{inheritDimensions: 'true', fitmode: 'FIT_BOTH'}"
					[mediaclip]="analyticsService.mediaclip"></bb-player>
			</bb-tile>

			<bb-tile class="stats-progress-tile" [headerBar]="false" *ngIf="analyticsService.activeId && analyticsService.activeType === 'mediaclip' && analyticsService.mediaclip?.timelines?.[0]">
				<stats-progress
					[showFilterWarning]="activeFilterList?.length > 0"
					[clipId]="analyticsService.activeId"
					(mediaclipChanged)="statsProgressMediaclipChanged($event)"
					mode="analytics-dashboard"
					[configuration]="statsProgressConfiguration">
				</stats-progress>
			</bb-tile>

			<!-- MEDIACLIP DETAILS: DROPOFF GRAPH -->
			<bb-tile
				class="mediaclip-details dropoff-tile"
				*ngIf="analyticsService.mediaclip && analyticsService.activeId && analyticsService.activeType === 'mediaclip' && !analyticsService.mediaclip?.timelines?.[0]"
				[headerBar]="true"
				[noData]="!analyticsService.facetData?.exactPercentageViewed"
				[loading]="mainGraphLoading || analyticsService.loadingData || (!playerClipLoaded && !analyticsService.mediaclipNotFound)">
				<span class="tile-title">
					{{ 'ENGAGEMENT' | translate }}
				</span>
				<div class="progress-chart-container" *ngIf="playerClipLoaded">
					<bb-chart [bbChartSettings]="{
						maxTicksLimitX: 7,
						maxLabelRotation: 0,
						axisTypeX: 'linear'
					}" [height]="250" [datasets]="analyticsService.pctViewedGraphDatasets" styling="analytics"
						(chartAreaChange)="updateChartArea($event)" (click)="progressIndicatorClick($event)"></bb-chart>
					<bb-canvas-element #canvasElement (canvasContextChange)="updateCanvasContext($event)" [height]="250">
					</bb-canvas-element>
				</div>
			</bb-tile>

			<!-- MAP -->
			<bb-tile class="map-tile" [menuOptions]="mapMenuOptions" (menuOptionSelected)="setMapFilter($event)"
				[loading]="mainGraphLoading || analyticsService.loadingData"
				[noData]="!analyticsService.facetData?.country">
				<div id="geochartContainer" #geochartContainer></div>
			</bb-tile>

			<!-- TOP MEDIACLIPS -->
			<bb-tile *ngIf="!analyticsService.activeId || analyticsService.activeType !== 'mediaclip'"
				class="clips-tile" [headerBar]="true" [loading]="analyticsService.loadingTopClips"
				[noData]="!topClipsData?.length">
				<span class="tile-title">
					{{ 'POPULAR_MEDIA_CLIPS' | translate }}
				</span>
				<div *ngIf="topClipsData?.length" class="clips-top10">
					<div class="clip-row">
						<div class="rank col-header">
							{{ 'RANK' | translate }}
						</div>
						<div class="blank col-header">
						</div>
						<div class="title col-header">
							{{ 'TITLE' | translate }}
						</div>
						<div class="count col-header">
							{{ 'VIEWS' | translate }}
						</div>
					</div>
					<ng-container *ngFor="let facetItem of topClipsData; let i = index;">
						<div class="clip-row" *ngIf="i < 10"
							[routerLink]="['/analytics/statistics/mediaclip/', facetItem.value]">
							<div class="clip-rank">
								<span class="rank-nr">{{ i + 1 }}</span>
							</div>
							<div class="clip-thumb">
								<i class="far fa-image-landscape placeholder"></i>
								<div class="thumb-wrapper"
									[innerHTML]="{type: 'mediaclip', id: facetItem.value} | thumbnail : 70:39 | async">
								</div>
							</div>
							<div class="clip-title">
								<div class="title-text">{{ facetItem.items?.title[0].value || ({type: 'commonclip',
									value: facetItem.value} | entityLabel | async) }}</div>
							</div>
							<div class="clip-count">{{ facetItem.count | number }}</div>
						</div>
					</ng-container>
				</div>
			</bb-tile>
		</div>
	</div>
</div>
